import AbstractListResource from './abstract/abstract-list-resource';
import {Resource, ContentType, Uid, ActionType} from 'sdk/src/defines';
import {AttributesType, ResourceApiCalls, SortFunc} from '../utility/types';
import Episode from './items/episode';

class Episodes extends AbstractListResource<Episode> {
    public resourceType: Resource = Resource.EPISODES;

    public resourceItemClass: typeof Episode = Episode;

    public sort: SortFunc = (a: Episode, b: Episode) => {
        if (a.props?.index < b.props?.index) {
            return -1;
        }

        if (a.props?.index > b.props?.index) {
            return 1;
        }

        return 0;
    };

    public allowedActions: ActionType[] = [
        ActionType.LIST,
        ActionType.GET,
        ActionType.UPDATE,
        ActionType.DELETE,
        ActionType.CREATE,
    ];

    public apiCalls: ResourceApiCalls = {
        list: (params: AttributesType) => this.api().resourceGet(Resource.CONTENTS, {type: ContentType.EPISODE, ...params}),
        get: (id: Uid, params: AttributesType) =>  this.api().resourceRead(Resource.CONTENTS, id, params),
        create: (params: AttributesType) => this.api().resourceCreate(Resource.CONTENTS, {type: ContentType.EPISODE, ...params}),
        update: (ids: Uid | Uid[], params: AttributesType) => this.api().resourceUpdate(Resource.CONTENTS, ids, params),
        delete: (ids: Uid | Uid[]) => this.api().resourceDelete(Resource.CONTENTS, ids),
    }

    public getConnectedResourceTypes(): Resource[] {
        return [Resource.CONTENTS];
    }

}

export {Episodes, Episode};

export default new Episodes();
